<section class="select-object-type">
    <h2 mat-dialog-title>Select Object Type</h2>
  
    <mat-dialog-content>
      <mat-radio-group [(ngModel)]="selectedType" class="radio-group">
        <mat-radio-button value="web"><span>Web Object</span></mat-radio-button>
        <mat-radio-button value="api" [featureActionState]="'API_TESTING'"><span>Api Object</span></mat-radio-button>
      </mat-radio-group>
    </mat-dialog-content>
  
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancel()"><span>Cancel</span></button>
      <button mat-raised-button [disabled]="!selectedType" (click)="onSubmit()"><span>Ok</span></button>
    </mat-dialog-actions>
  </section>
  